module.exports = __webpack_public_path__ + "img/circle-6.002eac7.png";